import { RoutesOrderWomen } from '@/enums/womenSignup'
import { Orientations } from '@/enums/products'
import { CountryCodes, CountrySelectOptionsLimited } from '@/enums/general'
import { serializeParameters } from '@/utils/general'

export default function ({ store: { state: { signup, app: appState } }, redirect, route }) {
  const { form: { paymentId }, addressConfirmed } = signup

  const isAvailableCountry = !!CountrySelectOptionsLimited.find(countryOption => countryOption?.value === appState.country)

  const i18Params = `/${appState.locale}-${isAvailableCountry ? appState.country : CountryCodes.netherlands}`

  const path = route.name.replace('lang-', '')
  const pathIndex = RoutesOrderWomen.findIndex(routeName => routeName === path)

  const queryParamsString = serializeParameters(route.query)

  const isPendingPage = pathIndex === 7
  const isEmailVerificationPage = pathIndex === 8
  const isSuccessPage = pathIndex === 5

  if (!isPendingPage && !isSuccessPage && !isEmailVerificationPage && pathIndex !== -1) {
    if (paymentId && pathIndex < 4) {
      return redirect(`${i18Params}/women/signup/create-account/verification-payment?${queryParamsString}`)
    }

    if (!(signup.form[Orientations.womenbralette].size.reference && signup.form[Orientations.womenhipster].size.reference) && pathIndex > 0) {
      return redirect(`${i18Params}/women/signup?${queryParamsString}`)
    }

    if (!(signup.form[Orientations.womenbralette].design.slug && signup.form[Orientations.womenhipster].design.slug) && pathIndex > 1) {
      return redirect(`${i18Params}/women/signup?${queryParamsString}`)
    }

    if (!signup.form.prospectId && pathIndex > 2) {
      return redirect(`${i18Params}/women/signup?${queryParamsString}`)
    }

    if (!addressConfirmed && pathIndex > 3) {
      return redirect(`${i18Params}/women/signup?${queryParamsString}`)
    }
  }

  if (!isAvailableCountry) {
    return redirect(`${i18Params}${route.fullPath.replace(`/${route.params.lang}`, '')}`)
  }
}
